export default __webpack_public_path__ + "assets/check_darkpurple.d2e0b4fa.svg";